import { gql } from '@apollo/client';

export const GET_BOOKMARKS = gql`
  query GET_BOOKMARKS {
    bookmarks {
      program {
        activatedAt
        completionTimeDisplay
        featured
        id
        maxCompletionDays
        maxCompletionTimeDisplay
        minCompletionDays
        minCompletionTimeDisplay
        name
        nextDate {
          appDueDate
          startDate
        }
        programFormat
        shortProgramKind
        studentFacingAcademicPartner {
          coachingIncluded
          informalName
          logoAltText
          merchandisingTier
          parentName
        }
        uuid
      }
    }
  }
`;
